import React, { useMemo } from 'react'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import { getAirportDisplayTextDropdown } from 'lib/flights/flightUtils'
import clsx from 'clsx'
import styled from 'styled-components'
import { rem } from 'polished'
import LineMapMarkerIcon from 'LuxKit/Icons/line/LineMapMarkerIcon'
import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'

interface Props {
  subRecord?: boolean;
  selected?: boolean;
  airport: App.AirportLocation;
  icon?: React.ReactNode;
  onSelectAirport: (airport: App.AirportLocation) => void;
  id?: string;
}

const StyledClickableListItem = styled(ClickableListItem)`
  &.sub-record {
    padding-left: ${rem(50)};
  }
`

function AirportDropdownOption(props: Props) {
  const { id, subRecord, selected, airport, icon, onSelectAirport } = props
  const { cityDesc, country } = airport
  const selectAirport = () => onSelectAirport(airport)

  // if airport code ends with ALL
  const isAllAirports = useMemo(() => {
    return airport.airportCode.endsWith('ALL') && airport.isMultiAirport
  }, [airport.airportCode, airport.isMultiAirport])

  const airportIcon = useMemo(() => {
    if (isAllAirports) {
      return <LineMapMarkerIcon colour="primary" />
    }

    if (subRecord) {
      return <LinePlaneDepartureIcon colour="primary" />
    }
    return icon ?? <LinePlaneDepartureIcon colour="primary" />
  }, [isAllAirports, subRecord, icon])

  return (
    <StyledClickableListItem
      size="medium"
      onClick={selectAirport}
      startIcon={airportIcon}
      className={clsx({ 'sub-record': subRecord && !isAllAirports })}
      title={getAirportDisplayTextDropdown(airport)}
      subtitle={isAllAirports ? country : `${cityDesc}, ${country}`}
      data-testid={`${id}-${airport.airportCode}`}
      selected={selected}
    />
  )
}

export default AirportDropdownOption
